/**
 * Error Log Service
 * Sends client-side errors to the backend for logging to Elasticsearch
 */

import { apiClient } from '@/infrastructure/api/client/apiClient';
import { logger } from '@/application/core';
import type { IHttpClient } from '@/application/core';
import type { ErrorInfo } from 'react';

interface ErrorLogPayload {
  message: string;
  stack?: string;
  componentStack?: string | null;
  timestamp: string;
  userAgent: string;
  url: string;
}

/**
 * Log an error to the backend endpoint.
 * Falls back to console.error if the request fails.
 */
export async function logErrorToBackend(
  error: Error,
  errorInfo: ErrorInfo,
  httpClient: IHttpClient = apiClient,
): Promise<void> {
  try {
    const payload: ErrorLogPayload = {
      message: error.message,
      stack: error.stack,
      componentStack: errorInfo.componentStack,
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
      url: window.location.href,
    };

    await httpClient.post('/api/errors', payload);
  } catch (loggingError) {
    logger.error('ErrorLogService', 'Failed to log error to backend:', loggingError);
    logger.error('ErrorLogService', 'Original error:', error, errorInfo);
  }
}
